<template>
  <div>
    <!-- id="bi-report" class="vs-con-loading__container" -->
    <vs-card>
      <vs-row class="mb-2">
        <vs-col vs-xs="12" vs-sm="10" vs-lg="10" class="px-2">
          <vs-row>
            <vs-col>
              <label class="text-sm opacity-75 px-1">{{ $t('client') }}</label>
            </vs-col>
            <vs-col>
              <v-select
                @input="loadDonut('client')"
                v-model="params.client"
                :placeholder="$t('Select')"
                :options="clients"
                class="w-full"
                :reduce="(client) => client.ClientId"
                label="ShortName"
              />
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col vs-xs="12" vs-sm="2" vs-lg="2" class="px-2">
          <vs-row>
            <vs-col>
              <label class="text-sm opacity-75 px-1">{{
                $t('currency')
              }}</label>
            </vs-col>
            <vs-col>
              <v-select
                @input="loadDonut('currency')"
                v-model="params.currency"
                :placeholder="$t('Select')"
                :options="currencies"
                class="w-full"
                :reduce="(currency) => currency.id"
                label="text"
              />
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col vs-xs="12" vs-sm="5" vs-lg="5" class="px-2">
          <vs-row>
            <vs-col>
              <label class="text-sm opacity-75 px-1">{{
                $t('initial_period')
              }}</label>
            </vs-col>
            <vs-col>
              <v-select
                @input="loadDonut('initial')"
                v-model="params.initialPeriod"
                :placeholder="$t('Select')"
                :options="periods"
                class="w-full"
                :reduce="(period) => period.PeriodId"
                label="PeriodLabel"
              />
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col vs-xs="12" vs-sm="5" vs-lg="5" class="px-2">
          <vs-row>
            <vs-col>
              <label class="text-sm opacity-75 px-1">{{
                $t('final_period')
              }}</label>
            </vs-col>
            <vs-col>
              <v-select
                @input="loadDonut('final')"
                v-model="params.finalPeriod"
                :placeholder="$t('Select')"
                :options="filteredPeriods"
                class="w-full"
                :reduce="(period) => period.PeriodId"
                label="PeriodLabel"
              />
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col vs-xs="12" vs-sm="2" vs-lg="2" class="px-2">
          <div class="mt-4">
            <export-button
              :data="this.params"
              :url="'bi/all/export/18375A_sk_sJKg_8SZxj_fu8ka99me'"
              :disabled="
                params.finalPeriod == null || params.client == null
                  ? true
                  : false
              "
            />
          </div>
        </vs-col>
      </vs-row>
    </vs-card>

    <vs-row>
      <vs-col
        vs-xs="12"
        :vs-sm="show.bar == false ? 12 : 6"
        :vs-lg="show.bar == false ? 12 : 6"
        class="pr-4"
      >
        <vs-card class="card-h" v-show="show.donut">
          <h4 class="mx-4">
            {{ $t('expenses_by_category') }}
          </h4>
          <bi-donut-chart
            :series="biDonutSeries"
            :chartId="'bi-donut'"
            :height="'400'"
            @clickDonutSection="handlerClickDonut"
            id="donut-chart"
            class="vs-con-loading__container"
          />
        </vs-card>
      </vs-col>
      <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="pl-4">
        <vs-card class="card-h" v-show="show.bar">
          <div slot="header">
            <h4 class="mx-4">
              {{ titleBar }}
            </h4>
          </div>
          <bi-bar-chart
            :chartData="chartData"
            @clickChart="handleClickChart"
            id="bar-chart"
            class="vs-con-loading__container"
          />
        </vs-card>
      </vs-col>
    </vs-row>

    <vs-card v-show="show.table">
      <vs-row vs-type="flex" vs-justify="flex-end" class="mb-4">
        <vs-col vs-xs="12" vs-sm="2" vs-lg="2" class="p-2" align="left">
        </vs-col>
        <vs-col vs-xs="12" vs-sm="3" vs-lg="3" class="p-2">
          <vs-input
            icon-pack="feather"
            icon="icon-search"
            :placeholder="$t('search')"
            class="w-full"
            v-model="params.search"
          />
        </vs-col>
        <vs-col vs-xs="12" vs-sm="2" vs-lg="2" class="p-2">
          <export-button
            :data="this.params"
            :url="'bi/table/export/oalRiSljg5456aAhs5__12AoA'"
          />
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col>
          <bi-report-table
            :data="filteredExpenses"
            :currency="params.currency"
            id="bi-report-table"
            class="vs-con-loading__container"
          />
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import accounting from '@/http/requests/accounting'
import invoice from '@/http/requests/invoice'
import client from '@/http/requests/client'
import moment from 'moment'

import BiDonutChart from '@/views/apps/accounting/components/BiDonutChart.vue'
import BiReportTable from '@/views/apps/accounting/components/BiReportTable.vue'
import BiBarChart from '@/views/apps/accounting/components/BiBarChart.vue'
import ExportButton from '@/views/components/ExportButton.vue'
import vSelect from 'vue-select'
import loading from '@/mixins/Loading.js'
import ComingSoonVue from '../../pages/ComingSoon.vue'
import moduleExpense from '@/store/expense/moduleExpense.js'


export default {
  components: {
    BiDonutChart,
    BiBarChart,
    BiReportTable,
    ExportButton,
    'v-select': vSelect,
  },
  computed: {
    expenses() {
      return this.$store.state.expense.expenseList
    },
    isLoading() {
      return this.loading.clients || this.loading.periods
    },
    filteredPeriods() {
      //  if (this.params.initialPeriod != null) {
      //   return this.periods.filter((item) => {
      //     return (parseInt(item.PeriodId) > parseInt(this.params.initialPeriod) && parseInt(item.PeriodId) <= parseInt(this.params.initialPeriod) + 53)
      //   });
      // }
      // return []
      if (this.params.initialPeriod != null) {
        let items = this.periods.filter((item) => {
          return parseInt(item.PeriodId) > parseInt(this.params.initialPeriod)
        });
        let periods = items.slice(items.length-52);
        return periods
      }
      return []
    },
    filteredExpenses() {
      if (this.expenses.length > 0) {
        return this.expenses.filter((item) => {
          return (item.Folio.toLowerCase().includes(this.params.search.toLowerCase()) ||
            (item.Year + ' - ' + item.Week).toLowerCase().includes(this.params.search.toLowerCase()) ||
            item.Year.toLowerCase().includes(this.params.search.toLowerCase()) ||
            this.formatDate(item.ReceivedDate).includes(this.params.search.toLowerCase())
            || item.VendorName.toLowerCase().includes(this.params.search.toLowerCase()))
        });
      }
      return []
    },
    showDonut() {
      return this.biDonutSeries.length > 0
    }
  },
  created() {
    if (!moduleExpense.isRegistered) {
      this.$store.registerModule('expense', moduleExpense)
      moduleExpense.isRegistered = true
    }
  },
  data: () => ({
    clients: [],
    periods: [],
    biDonutSeries: [],
    currencies: [
      { id: 'USD', text: 'USD' },
      { id: 'MXN', text: 'MXN' },
    ],
    params: {
      client: null,
      initialPeriod: null,
      finalPeriod: null,
      currency: 'USD',
      categoryName: null,
      month: null,
      lastYear: false,
      search: ''
    },
    titleBar: '',
    colorBar: null,
    chartData: {
      series: [],
      categories: [],
      colors: []
    },
    loading: {
      clients: false,
      periods: false
    },
    show: {
      donut: false,
      bar: false,
      table: false
    },
    lastYear: '',
  }),
  mixins: [loading],
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getClients()
      this.getPeriods()
      this.loadDonut()
    },
    getClients() {
      this.loading.clients = true
      client.list().then((res) => {
        this.clients = res.data.clients
        this.loading.clients = false
      })
        .catch(err => {
          this.loading.clients = false
        })
    },
    formatDate(date) {
      moment.locale('es');
      return moment(date).format('L')
    },
    getPeriods() {
      this.loading.periods = true
      invoice.getPeriodList().then((res) => {
        this.periods = res.data.periodList
    this.periods = this.periods.filter(item => item.Week != "850")
        this.loading.periods = false
        moment.locale('es');
        let today = moment().format('Y-MM-DD')
        let currentPeriod = this.periods.filter((item) => {
          return (
            item.BeginDate <= today &&
            item.EndDate >= today
            )
        })
        this.params.initialPeriod = currentPeriod.length !=0 ? currentPeriod[0].PeriodId:null
      })
        .catch(err => {
          this.loading.periods = false
        })
    },
    loadDonut(selectName) {
      if (selectName == 'initial') {
        this.params.finalPeriod = null
      }
      if (
        this.params.client == null ||
        this.params.initialPeriod == null ||
        this.params.finalPeriod == null ||
        this.params.currency == null
      ) {
        return
      }
      this.show.table = false
      this.show.bar = false
      this.show.donut = true

      this.refreshDonut()
    },
    refreshDonut() {
      this.openLoading('donut-chart')
      this.openLoading('bar-chart')
      this.openLoading('bi-report-table')

      accounting.biReportDonutInfo(this.params)
        .then((res) => {
          this.resetBar()
          this.fillDonut(res.data.data, this.params.currency)
          this.closeLoading('donut-chart')
          this.closeLoading('bar-chart')
          this.closeLoading('bi-report-table')
        })
        .catch(err => {
          this.closeLoading('donut-chart')
          this.closeLoading('bar-chart')
          this.closeLoading('bi-report-table')
        })
    },
    refreshBar() {
      this.openLoading('bar-chart')
      accounting.biReportBarInfo(this.params)
        .then((res) => {
          this.fillBar(res.data.data, this.params.currency)
          this.closeLoading('bar-chart')
        })
        .catch(err => {
          this.closeLoading('bar-chart')
        })
    },
    fillDonut(dataToChart, currency) {
      let total = 0
      let totalLast = 0
      let seriesArray = []
      let labelsArray = []
      let colorsArray = []
      if (dataToChart.length == 0) {
        seriesArray = [0]
        labelsArray = ['NO LABEL']
        colorsArray = ['#FFFFFF']
      } else {
        dataToChart.forEach((element) => {
          totalLast = currency == 'USD' ? totalLast + Number(element.TotalUSDLast) : totalLast + Number(element.TotalMXNLast)
          total = currency == 'USD' ? total + Number(element.TotalUSD) : total + Number(element.TotalMXN)
          seriesArray[seriesArray.length] = currency == 'USD' ? Number(element.TotalUSD) : Number(element.TotalMXN)
          labelsArray[labelsArray.length] = element.CategoryName != null ? element.CategoryName : 'No label'
          colorsArray[colorsArray.length] = element.color != null ? element.color : '#000000'
        })
      }

      this.biDonutSeries = seriesArray
      ApexCharts.exec(
        'bi-donut',
        'updateOptions',
        {
          fill: {
            colors: colorsArray,
          },
          legend: {
            markers: {
              fillColors: colorsArray,
            },
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  total: {
                    label: '$ ' + total.toLocaleString('en-US'),
                    formatter: function () {
                      return 'Last Year $' + totalLast.toLocaleString('en-US')
                    }
                  }
                }
              }
            }
          },
          labels: labelsArray,
          tooltip: {
            fillSeriesColor: false,
          }
        },
        false,
        true
      )
    },
    fillBar(dataToBar, currency) {
      let series = []
      let series1 = []
      let series2 = []
      let categories = []
      dataToBar.forEach((element) => {
        series1[series1.length] = currency == 'USD' ? Number(element.TotalLastUSD) : Number(element.TotalLastMXN)
        series2[series2.length] = currency == 'USD' ? Number(element.TotalUSD) : Number(element.TotalMXN)
        categories[categories.length] = Number(element.MonthNum)
      })
      series = [
        {
          name: 'Last Year',
          data: series1
        },
        {
          name: 'Selected Period',
          data: series2
        }
      ]
      let colors = [this.colorBar + '75', this.colorBar]
      this.chartData = Object.assign({}, this.chartData, { series, categories, colors })
      this.titleBar = this.params.categoryName
    },
    resetBar() {
      let series = []
      let categories = []
      this.titleBar = null
      this.chartData = Object.assign({}, this.chartData, { series, categories })
    },
    handlerClickDonut(config) {
      this.params.categoryName = config.w.config.labels[config.dataPointIndex]
      this.colorBar = config.w.config.fill.colors[config.dataPointIndex]
      this.show.bar = true
      this.show.table = false
      this.refreshBar()
    },
    handleClickChart(config) {
      const serie = config.w.config.series[config.seriesIndex].name
      const month = config.w.config.xaxis.categories[config.dataPointIndex] //ok
      this.show.table = true
      this.params.month = month
      this.params.lastYear = serie
      this.openLoading('bi-report-table')
      this.$store.dispatch('expense/fetchBiReportTableList', this.params)
        .then(res => {
          this.closeLoading('bi-report-table')
        })
        .catch(err => {
          this.closeLoading('bi-report-table')
        })
    }
  },
  watch: {
    // isLoading(val) {
    //   if (val) {
    //     this.openLoading('bi-report')
    //   } else {
    //     this.closeLoading('bi-report')
    //   }
    // }
  },
}
</script>

<style>
.card-h {
  height: 450px;
}
.apexcharts-text .apexcharts-datalabel-value {
  font-size: 20;
}
</style>